import { Box, Button, SxProps, Typography } from '@mui/material';
import {
  code as codeSx,
  descText,
  errorText as errorTextSx,
  infoText,
  warningBox,
} from './AsanVerifyingView.sx';
import BackButton from 'app/components/BackButton';
import CountdownTimer from 'app/components/CountdownTimer';
import WarningIcon from 'app/components/Icons/WarningIcon';
import { useTranslation } from 'react-i18next';

interface Props {
  asanModalType?: string;
  btnSx?: SxProps;
  verificationCode?: string;
  timerTime?: any;
  isErrorResult: boolean;
  error?: { text?: string };
  onRepeat: () => void;
  onCancel: () => void;
  /** Used by the 'transfer' (dialog) mode close button. */
  onClose?: () => void;
}

/** Waiting screen: verification code, countdown and cancel/back controls. */
const AsanVerifyingView = ({
  asanModalType,
  btnSx,
  verificationCode,
  timerTime,
  isErrorResult,
  error,
  onRepeat,
  onCancel,
  onClose,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
      }}
    >
      <Box>
        {asanModalType !== 'transfer' && (
          <Typography sx={infoText}>{t('confirm.confirmAsanImza')}</Typography>
        )}
        <Typography sx={descText}>{t('confirm.asanImzaDesc')}</Typography>
        <Typography sx={codeSx}>{verificationCode}</Typography>
        <CountdownTimer repeat={onRepeat} timerTime={timerTime} errorCase={isErrorResult} />
        {error && (
          <Box sx={warningBox}>
            <WarningIcon sx={{ mr: '16px' }} />
            <Typography sx={errorTextSx}>{error.text}</Typography>
          </Box>
        )}
      </Box>
      {asanModalType === 'transfer' ? (
        <Button
          sx={btnSx}
          color={'secondary'}
          onClick={() => {
            onCancel();
            onClose();
          }}
        >
          {t('commonActions.close')}
        </Button>
      ) : (
        <BackButton btnSx={btnSx} text={'confirm.back'} asan={true} cancel={onCancel} />
      )}
    </Box>
  );
};

export default AsanVerifyingView;
